/* Pure selection logic. Prices and options always come from Shopify. */
(function (scope) {
  const match = (record, selection) =>
    (!record.finish || record.finish === selection.finish) &&
    (!record.size || record.size === selection.size) &&
    (!record.cropStyle || record.cropStyle === selection.cropStyle);
  const score = record => (record.cropStyle ? 4 : 0) + (record.size ? 2 : 0) + (record.finish ? 1 : 0);
  function recordFor(records, selection) {
    return records.filter(record => match(record, selection))
      .sort((a, b) => score(b) - score(a))[0];
  }
  function variantFor(data, selection) {
    return data.variants.find(variant => data.options.every((option, index) =>
      variant.options[index] === optionValue(data, option, selection)));
  }
  function optionValue(data, option, selection) {
    if (option.role !== 'finish') return selection[option.role];
    // A native bundle finish encodes crop style on the order while the UI
    // retains the approved four customization choices and separate crop control.
    if (data.nativeCropFinishes && /^Crop(?: \+ Distress)?$/.test(selection.finish)) {
      if (!selection.cropStyle) return null;
      return selection.cropStyle + (selection.finish === 'Crop + Distress' ? ' + Distress' : '');
    }
    return selection.finish;
  }
  function finishMatches(data, variant, finish) {
    return data.options.every((option, index) => {
      if (option.role !== 'finish') return true;
      const value = variant.options[index];
      if (data.nativeCropFinishes && finish === 'Crop') return value === 'Natural Crop' || value === 'Baby Crop';
      if (data.nativeCropFinishes && finish === 'Crop + Distress') return value === 'Natural Crop + Distress' || value === 'Baby Crop + Distress';
      return value === finish;
    });
  }
  function propertiesFor(record, selection, baseProduct) {
    // Shopify's paid variant already stores the product, size and customization.
    // Crop Style is essential where the native variant only says Crop.
    const properties = {};
    if (selection.fit) {
      const painted = selection.finish === 'Painted';
      properties['_Production Instructions'] = selection.fit === 'Cropped'
        ? 'Use full-length blank. Cut to approved cropped length. ' + (painted ? 'Apply hand-painted finish.' : 'No paint.')
        : 'Use full-length blank. ' + (painted ? 'Preserve original full-length hem. Apply hand-painted finish.' : 'Leave original bottom hem intact. No paint.');
      return properties;
    }
    if (record?.requiresCrop) properties['Crop Style'] = selection.cropStyle;
    // Private properties remain on the order for fulfillment, hidden at checkout.
    if (record?.production && record.production !== 'Original — no additional customization') {
      properties['_Production Instructions'] = record.production;
    }
    return properties;
  }
  const api = {recordFor, variantFor, propertiesFor, finishMatches};
  scope.DrkConfiguration = api;
  if (typeof module !== 'undefined') module.exports = api;
})(typeof window === 'undefined' ? globalThis : window);
